import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

export const AreaC_Hatchback_Center: React.FC<AreaSVGProps> = ({
  fill = '#148B4D',
  stroke = '#148B4D',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="126"
      height="23"
      viewBox="0 0 126 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_c_hatchback_center"
          x="0"
          y="0"
          width="126"
          height="23"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
      <g filter="url(#filter_area_c_hatchback_center)">
        <path
          d="M1.43652 0C19.6675 4.84869 41.8642 7.22135 62.6299 7.31641H62.667L64.7734 7.29883C84.8851 7.05893 106.16 4.69396 123.757 0.0263672L125.007 7.85645L125.216 16.6035C108.57 19.9864 88.0057 22.1538 62.6475 22.4609C37.2495 22.1532 16.6599 19.9789 0 16.5869V7.85254L1.43652 0Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
